<app-card>
  <table class="card">
    <tr>
      <th>Bank account</th>
      <td>
        <a [routerLink]="['/bank-accounts', bankAccount.id]">{{ bankAccount.name }}</a>
      </td>
    </tr>
    <tr>
      <th>Time</th>
      <td>{{ importLog.datetime | firestoreTimestamp:'YYYY-MM-DD HH:mm:ss' }}</td>
    </tr>
    <tr>
      <th>Filename</th>
      <td>{{ importLog.filename }}</td>
    </tr>
    <tr>
      <th>Statement</th>
      <td>{{ importLog.statement }}</td>
    </tr>
    <tr>
      <th>Status</th>
      <td>{{ importLog.status }}</td>
    </tr>
  </table>
</app-card>
